export default __webpack_public_path__ + "static/media/banner-img1.32114ec4.png";